import {Controller} from '@hotwired/stimulus';
import {useClickOutside, useTransition} from 'stimulus-use';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['sidebar', 'hideButton', 'term'];

    connect() {
        useClickOutside(this, {
            element: this.sidebarTarget,
            dispatchEvent: false,
        });
        useTransition(this, {
            element: this.sidebarTarget,
            // enterActive: 'transition ease-out duration-300',
            // enterFrom: 'transform opacity-0 translate-x-full',
            // enterTo: 'transform opacity-100 translate-x-0',
            leaveActive: 'transition ease-in duration-300',
            leaveFrom: 'transform opacity-100 translate-x-0',
            leaveTo: 'transform opacity-0 translate-x-full',
        });

        this.scrollUpLinks.forEach((element) => {
            element.addEventListener('click', () => {
                this.filterChanged();
            });
        });

        if (window.location.hash === '#search') {
            this.filterChanged();
        }
    }

    disconnect() {
        this.scrollUpLinks.forEach((element) => {
            element.removeEventListener('click', () => {
                this.filterChanged();
            });
        });
    }

    filterChanged() {
        this.dispatch('filterChange', {detail: {}});
    }

    clickOutside() {
        if (!this.sidebarTarget.classList.contains('transform') && !this.sidebarTarget.classList.contains('hidden')) {
            this.close();
        }
    }

    open() {
        this.enter();
        this.hideButtonTarget.focus();
    }

    close() {
        this.leave();
    }

    filter(e) {
        e.preventDefault();
        e.stopPropagation();
        if (e.params.url) {
            if (typeof Turbo !== 'undefined') {
                // eslint-disable-line no-undef
                Turbo.visit(e.params.url); // eslint-disable-line no-undef
            } else {
                window.location.href = e.params.url;
            }
        }
    }

    selectFilter(e) {
        e.preventDefault();
        e.stopPropagation();

        if (e.params.param) {
            let url = new URL(window.location.href);

            url.searchParams.delete(e.params.param);
            url.searchParams.delete('page');
            if (e.srcElement.value !== '') {
                url.searchParams.append(e.params.param, e.srcElement.value);
            }

            if (typeof Turbo !== 'undefined') {
                // eslint-disable-line no-undef
                Turbo.visit(url.toString()); // eslint-disable-line no-undef
            } else {
                window.location.href = url.toString();
            }

            this.filterChanged();
        }
    }

    clearTerm() {
        if (this.hasTermTarget) {
            this.termTarget.value = '';
        }
    }

    get scrollUpLinks() {
        return this.element.querySelectorAll('.scrollup');
    }
}
